import React, { useState, useEffect, useRef, useMemo } from "react";
import data from "../../../file/data2.json";
import { w3cwebsocket as W3CWebSocket } from "websocket";
import * as Cesium from "cesium";
import AuthServiceV2 from "../../../services/auth.serviceV2.js";
import AuthServiceV3 from "../../../services/Operation.serviceV3.js";

const DroneMonitorSocket = () => {
  Cesium.Ion.defaultAccessToken =
    "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiI4YTkzY2UxMS1kMzE1LTQ5OTgtYjZjYS1lYjQ0ZmI2M2Q5ODMiLCJpZCI6MTAyMzYwLCJpYXQiOjE2NTg3MTU3NzZ9.JRrIwyF6xYiIdmIiP9ezmq4siqacN1K6ObnYnjpfHVc";

  const timeStepInSeconds = 30;
  const totalSeconds = timeStepInSeconds * (data.length - 1);
  const start = Cesium.JulianDate.fromIso8601("2020-03-09T23:10:00Z");
  const stop = Cesium.JulianDate.addSeconds(
    start,
    totalSeconds,
    new Cesium.JulianDate()
  );
  const positionProperty = new Cesium.SampledPositionProperty();
  const mapRef = useRef(null);
  const cesium = useRef(null);

  useEffect(() => {
    Cesium.Ion.defaultAccessToken =
      "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiI4ZjMzYjE4Yi0yOTdjLTQwM2QtYTE1ZC03NmVlOWYxYTkwOWMiLCJpZCI6MTQ1NDE4LCJpYXQiOjE2ODYyMDU1MjF9.v9-Cb1DuW8J1rrEXixkabo69xxSEkS_729lv7vtBba8";
    const socket = new WebSocket("ws://172.27.184.102:6080");
    const viewer = new Cesium.Viewer(mapRef.current, {
      // sceneMode: Cesium.SceneMode.SCENE2D,
      scene3DOnly: true,
      timeline: false,
      animation: false,
      baseLayerPicker: false,
      selectionIndicator: false,
      infoBox: true,
    });
    const handler = new Cesium.ScreenSpaceEventHandler(viewer.canvas);
    const globe = viewer.scene.globe;

    viewer.scene.screenSpaceCameraController.enableRotate = true;
    viewer.scene.screenSpaceCameraController.enableTranslate = true;
    viewer.scene.screenSpaceCameraController.enableZoom = true;
    viewer.scene.screenSpaceCameraController.enableTilt = false;
    viewer.scene.screenSpaceCameraController.enableLook = false;

    viewer.screenSpaceEventHandler.setInputAction(function () {},
    Cesium.ScreenSpaceEventType.LEFT_DOUBLE_CLICK);

    //Click to get Border
    // handler.setInputAction(function (movement) {
    //   const pickedObject = viewer.scene.pick(movement.position);
    //   if (Cesium.defined(pickedObject) && Cesium.defined(pickedObject.id)) {
    //     isClicking = pickedObject.id.id;
    //   } else {
    //     isClicking = null;
    //     showCoordinates(viewer.scene, movement.position);
    //   }
    // }, Cesium.ScreenSpaceEventType.LEFT_DOWN);

    let anchorPoint = [0, 0];

    flyToLocation();
    function flyToLocation() {
      function fly(position) {
        viewer.camera.setView({
          // destination: Cesium.Cartesian3.fromDegrees(
          //   position.coords.longitude,
          //   position.coords.latitude,
          //   1000.0
          // ),
          destination: Cesium.Cartesian3.fromDegrees(
            100.60043542133313,  14.045937753285655,
            1000.0
          ),
        });
        // showCoordinates(position.coords.longitude, position.coords.latitude);
        showCoordinates(100.60043542133313,  14.045937753285655);
      }

      // Ask browser for location, and fly there.
      navigator.geolocation.getCurrentPosition(fly);
    }

    // const clippingAnchor = Cesium.Cartographic.toCartesian(
    //   new Cesium.Cartographic.fromDegrees(anchorPoint[0], anchorPoint[1], 9000)
    // );
    // const distanceAnchor = 4500.0;

    // globe.clippingPlanes = new Cesium.ClippingPlaneCollection({
    //   modelMatrix: Cesium.Transforms.eastNorthUpToFixedFrame(clippingAnchor),
    //   planes: [
    //     new Cesium.ClippingPlane(
    //       new Cesium.Cartesian3(1.0, 0.0, 0.0),
    //       distanceAnchor
    //     ),
    //     new Cesium.ClippingPlane(
    //       new Cesium.Cartesian3(-1.0, 0.0, 0.0),
    //       distanceAnchor
    //     ),
    //     new Cesium.ClippingPlane(
    //       new Cesium.Cartesian3(0.0, 1.0, 0.0),
    //       distanceAnchor
    //     ),
    //     new Cesium.ClippingPlane(
    //       new Cesium.Cartesian3(0.0, -1.0, 0.0),
    //       distanceAnchor
    //     ),
    //   ],
    //   unionClippingRegions: true,
    //   edgeWidth: 1.0,
    //   edgeColor: Cesium.Color.WHITE,
    //   enabled: true,
    // });

    const imageName = new Image();
    imageName.crossOrigin = "anonymous";
    imageName.src =
      "https://i.ibb.co/ZV3xFvR/Untitled-design-10-removebg-preview.png";

    const onMessageData = {};
    const entityMap = {};
    const updatingData = {};

    const headingCoordinates = {};

    let isClicking = null;
    const trailCoordinates = {};

    let getDistanceOfEntity;

    let countDownEllipse = 0;

    // viewer.camera.setView({
    //   destination: Cesium.Cartesian3.fromDegrees(
    //     100.93052634878738,
    //     13.102477738906614,
    //     3000.0
    //   ),
    // });

    socket.onopen = function (event) {
      console.log("WebSocket connection established");
    };

    socket.onerror = function (error) {
      console.error("WebSocket error: ", error);
    };

    socket.onclose = function (event) {
      console.log("WebSocket connection closed");
    };

    function getDescription(id, name, speed, headDirection, dataTimeStamp) {
      return (
        "<table class='cesium-infoBox-defaultTable'>" +
        "<tr>" +
        "<th>Content</th>" +
        "<th>Value</th>" +
        "</tr>" +
        "<tr>" +
        "<td>Drone ID</td>" +
        `<td>${id}</td>` +
        "</tr>" +
        "<tr>" +
        "<tr>" +
        "<td>Drone Name</td>" +
        `<td>${name}</td>` +
        "</tr>" +
        "<tr>" +
        "<tr>" +
        "<td>Speed</td>" +
        `<td>${speed.toFixed(2)} km/h</td>` +
        "</tr>" +
        "<tr>" +
        "<td>Heading Degree</td>" +
        `<td>${headDirection}</td>` +
        "</tr>" +
        "<tr>" +
        "<td>Timestamp</td>" +
        `<td>${dataTimeStamp}</td>` +
        "</tr>" +
        "</table>"
      );
    }

    function isValidLatitude(latitude) {
      return typeof latitude === "number" && latitude >= -90 && latitude <= 90;
    }
    function isValidLongitude(longitude) {
      return (
        typeof longitude === "number" && longitude >= -180 && longitude <= 180
      );
    }
    function getPingRate(timeA, timeB) {
      if (timeA === undefined) {
        return "greenyellow";
      }
      let currentlyTime = Math.floor(new Date().getTime());
      // console.log("currentlyTime -> ", currentlyTime);
      // console.log("timeB -> ", timeB);
      const timePing = (currentlyTime - timeB * 1000) / 1000;

      if (timePing < 10) {
        return "greenyellow";
      } else if (timePing >= 10 && timePing < 30) {
        return "orange";
      } else {
        return "red";
      }
    }

    let actualBorderPolygon = viewer.entities.add({
      name: "Border actual display",
      polygon: null,
    });
    let blurBorderPolygon = viewer.entities.add({
      name: "Border blur display",
      polygon: null,
    });

    // function showCoordinates(scene, position) { // this is old for clickable
    function showCoordinates(longitude, latitude) {
      // console.log(scene, position)
      // const ellipsoid = scene.globe.ellipsoid;
      // const cartesian = viewer.camera.pickEllipsoid(position, ellipsoid);

      // if (cartesian) {
      // const cartographic = ellipsoid.cartesianToCartographic(cartesian);
      // const longitude = Cesium.Math.toDegrees(cartographic.longitude);
      // const latitude = Cesium.Math.toDegrees(cartographic.latitude);

      // anchorPoint = [
      //   parseFloat(longitude.toFixed(8)),
      //   parseFloat(latitude.toFixed(8)),
      // ]; old

      anchorPoint = [100.60043542133313,  14.045937753285655];

      actualBorderPolygon.polygon = {
        hierarchy: {
          positions: Cesium.Cartesian3.fromDegreesArray([
            longitude + 0.045,
            latitude + 0.045,
            longitude - 0.045,
            latitude + 0.045,
            longitude - 0.045,
            latitude - 0.045,
            longitude + 0.045,
            latitude - 0.045,
          ]),
          holes: [
            {
              positions: Cesium.Cartesian3.fromDegreesArray([
                longitude - 0.0448,
                latitude - 0.0448,
                longitude + 0.0448,
                latitude - 0.0448,
                longitude + 0.0448,
                latitude + 0.0448,
                longitude - 0.0448,
                latitude + 0.0448,
              ]),
            },
          ],
        },
        material: Cesium.Color.RED.withAlpha(0.5),
        height: 0,
        outline: true, // height is required for outline to display
        outlineColor: Cesium.Color.RED,
      };

      blurBorderPolygon.polygon = {
        hierarchy: {
          positions: Cesium.Cartesian3.fromDegreesArray([
            longitude + 0.02,
            latitude + 0.02,
            longitude - 0.02,
            latitude + 0.02,
            longitude - 0.02,
            latitude - 0.02,
            longitude + 0.02,
            latitude - 0.02,
          ]),
          holes: [
            {
              positions: Cesium.Cartesian3.fromDegreesArray([
                longitude - 0.0198,
                latitude - 0.0198,
                longitude + 0.0198,
                latitude - 0.0198,
                longitude + 0.0198,
                latitude + 0.0198,
                longitude - 0.0198,
                latitude + 0.0198,
              ]),
            },
          ],
        },
        material: Cesium.Color.YELLOW.withAlpha(0.5),
        height: 0,
        outline: true,
        outlineColor: Cesium.Color.YELLOW,
      };
      // }
    }

    function haversineDistance(lon1, lat1, lon2, lat2) {
      const toRadians = (degrees) => (degrees * Math.PI) / 180;
      const R = 6371.0;
      const dLat = toRadians(lat2 - lat1);
      const dLon = toRadians(lon2 - lon1);
      const a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(toRadians(lat1)) *
          Math.cos(toRadians(lat2)) *
          Math.sin(dLon / 2) *
          Math.sin(dLon / 2);
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      const distance = R * c;
      return distance;
    }

    function calculateSpeed(lon1, lat1, time1, lon2, lat2, time2) {
      const distance = haversineDistance(lat1, lon1, lat2, lon2);

      const timeDiffInHours = (time2 - time1) / 3600.0;
      const speed = distance / timeDiffInHours;
      if (isNaN(parseInt(speed))) {
        return 0;
      }
      return speed;
    }

    function calculateHeading(droneId, lon, lat) {
      if (!headingCoordinates.hasOwnProperty(droneId)) {
        headingCoordinates[droneId] = { lon, lat };
        return null;
      }

      const toRadians = (degrees) => (degrees * Math.PI) / 180;
      const toDegrees = (radians) => (radians * 180) / Math.PI;

      const { lon: prevLon, lat: prevLat } = headingCoordinates[droneId];

      const dLon = toRadians(lon - prevLon);
      const lat1Rad = toRadians(prevLat);
      const lat2Rad = toRadians(lat);

      const y = Math.sin(dLon) * Math.cos(lat2Rad);
      const x =
        Math.cos(lat1Rad) * Math.sin(lat2Rad) -
        Math.sin(lat1Rad) * Math.cos(lat2Rad) * Math.cos(dLon);
      const initialBearing = toDegrees(Math.atan2(y, x));

      headingCoordinates[droneId] = { lon, lat };

      return initialBearing;
    }

    function determineDirection(degree) {
      degree = parseInt(degree);
      if (degree < 0) {
        degree = 360 + (degree % 360);
      }

      if (degree >= 337.5 || degree < 22.5) {
        return `${degree}° (North)`;
      } else if (degree >= 22.5 && degree < 67.5) {
        return `${degree}° (North East)`;
      } else if (degree >= 67.5 && degree < 112.5) {
        return `${degree}° (East)`;
      } else if (degree >= 112.5 && degree < 157.5) {
        return `${degree}° (South East)`;
      } else if (degree >= 157.5 && degree < 202.5) {
        return `${degree}° (South)`;
      } else if (degree >= 202.5 && degree < 247.5) {
        return `${degree}° (South West)`;
      } else if (degree >= 247.5 && degree < 292.5) {
        return `${degree}° (West)`;
      } else if (degree >= 292.5 && degree < 337.5) {
        return `${degree}° (North West)`;
      }
    }

    function getReadableTime(time) {
      // console.log("Time -> ", time);
      const date = new Date(time * 1000);
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      const seconds = String(date.getSeconds()).padStart(2, "0");
      const readableTime = `${hours}:${minutes}:${seconds}`;
      // console.log("readableTime => ", readableTime);
      return readableTime;
    }

    function getValidatedData(item) {
      let validatingDataLength = item.id;
      let stepOfValidatingData = 1;
      let indexOfValidatingData = validatingDataLength - stepOfValidatingData;
      let validatedSpeedData = 0;

      if (validatingDataLength - 1 >= 0) {
        validatedSpeedData = calculateSpeed(
          item.lon[indexOfValidatingData - 1],
          item.lat[indexOfValidatingData - 1],
          item.time[indexOfValidatingData - 1],
          item.lon[indexOfValidatingData],
          item.lat[indexOfValidatingData],
          item.time[indexOfValidatingData]
        );
      }

      if (
        isValidLatitude(item.lat[indexOfValidatingData]) &&
        isValidLongitude(item.lon[indexOfValidatingData])
      ) {
        // console.log(
        //   "Item.Time => ",
        //   getReadableTime(item.time[indexOfValidatingData])
        // );
        return [
          item.name,
          item.lat[indexOfValidatingData],
          item.lon[indexOfValidatingData],
          item.height[indexOfValidatingData],
          getReadableTime(item.time[indexOfValidatingData]),
          getPingRate(
            item.time[indexOfValidatingData - 1],
            item.time[indexOfValidatingData]
          ),
          validatedSpeedData,
        ];
      }
    }

    function getRandomCoordinate(lat, lon) {
      let outputLat;
      let outputLon;

      const negativeLat = lat < anchorPoint[1];
      const negativeLon = lon < anchorPoint[0];

      if (negativeLat) {
        outputLat =
          lat +
          parseFloat((Math.random() * (0.0004 - 0.0008) - 0.0004).toFixed(4));
      } else {
        outputLat =
          lat +
          parseFloat((Math.random() * (0.0008 - 0.0004) + 0.0004).toFixed(4));
      }

      if (negativeLon) {
        outputLon =
          lon +
          parseFloat((Math.random() * (0.0004 - 0.0008) - 0.0004).toFixed(4));
      } else {
        outputLon =
          lon +
          parseFloat((Math.random() * (0.0006 - 0.0004) + 0.0004).toFixed(4));
      }

      return [outputLat, outputLon];
    }

    // const bluePolygon = viewer.entities.add({
    //   name: "Blue polygon with holes",
    //   polygon: {
    //     hierarchy: {
    //       positions: Cesium.Cartesian3.fromDegreesArray([
    //         anchorPoint[0] + 0.02,
    //         anchorPoint[1] + 0.02,
    //         anchorPoint[0] - 0.02,
    //         anchorPoint[1] + 0.02,
    //         anchorPoint[0] - 0.02,
    //         anchorPoint[1] - 0.02,
    //         anchorPoint[0] + 0.02,
    //         anchorPoint[1] - 0.02,
    //       ]),
    //       holes: [
    //         {
    //           positions: Cesium.Cartesian3.fromDegreesArray([
    //             anchorPoint[0] - 0.0198,
    //             anchorPoint[1] - 0.0198,
    //             anchorPoint[0] + 0.0198,
    //             anchorPoint[1] - 0.0198,
    //             anchorPoint[0] + 0.0198,
    //             anchorPoint[1] + 0.0198,
    //             anchorPoint[0] - 0.0198,
    //             anchorPoint[1] + 0.0198,
    //           ]),
    //         },
    //       ],
    //     },
    //     material: Cesium.Color.RED.withAlpha(0.5),
    //     height: 0,
    //     outline: true, // height is required for outline to display
    //     outlineColor: Cesium.Color.RED,
    //   },
    // });

    setInterval(function () {
      const availableKeys = Object.keys(onMessageData);
      for (let id of availableKeys) {
        if (onMessageData[id].id !== 0) {
          const [name, lat, lon, height, dataTimeStamp, color, speed] =
            getValidatedData(onMessageData[id]);
          let headDegree = calculateHeading(id, lon, lat);
          let headDirection = determineDirection(headDegree);
          let desiredDirection;
          if (headDirection === undefined) {
            desiredDirection = 0;
          } else {
            desiredDirection = Cesium.Math.toRadians(-headDegree);
          }
          getDistanceOfEntity = haversineDistance(
            anchorPoint[0],
            anchorPoint[1],
            lon,
            lat
          );

          function verifyDistancing(lon1, lat1, lon2, lat2) {
            const targetCoordinate = { lat: lat2, lon: lon2 };
            const cornerA = { lat: lat1 + 0.045, lon: lon1 + 0.045 };
            const cornerB = { lat: lat1 - 0.045, lon: lon1 - 0.045 };
            const cornerC = { lat: lat1 + 0.02, lon: lon1 + 0.02 };
            const cornerD = { lat: lat1 - 0.02, lon: lon1 - 0.02 };

            const minLatA = Math.min(cornerA.lat, cornerB.lat);
            const maxLatA = Math.max(cornerA.lat, cornerB.lat);
            const minLonA = Math.min(cornerA.lon, cornerB.lon);
            const maxLonA = Math.max(cornerA.lon, cornerB.lon);

            const minLatB = Math.min(cornerC.lat, cornerD.lat);
            const maxLatB = Math.max(cornerC.lat, cornerD.lat);
            const minLonB = Math.min(cornerC.lon, cornerD.lon);
            const maxLonB = Math.max(cornerC.lon, cornerD.lon);

            if (
              targetCoordinate.lat >= minLatA &&
              targetCoordinate.lat <= maxLatA &&
              targetCoordinate.lon >= minLonA &&
              targetCoordinate.lon <= maxLonA
            ) {
              if (
                targetCoordinate.lat >= minLatB &&
                targetCoordinate.lat <= maxLatB &&
                targetCoordinate.lon >= minLonB &&
                targetCoordinate.lon <= maxLonB
              ) {
                return "Inbound";
              } else {
                return "OutOfLimitedBound";
              }
            } else {
              return "OutOfBound";
            }
          }

          // console.log(`validatedData : `, lat, lon, height, color);
          if (
            entityMap.hasOwnProperty(id) === false &&
            verifyDistancing(anchorPoint[0], anchorPoint[1], lon, lat) ===
              "Inbound"
          ) {
            entityMap[id] = viewer.entities.add({
              id: id,
              name: `Drone - ${id}`,
              position: Cesium.Cartesian3.fromDegrees(lon, lat),
              label: {
                text: name,
                style: "FILL",
                scale: 0.75,
                pixelOffset: new Cesium.Cartesian2(0, -40),
                zIndex: 3,
              },
              description: getDescription(id, name, speed),
              billboard: {
                image: imageName,
                scale: 0.07,
                ready: true,
                rotation: desiredDirection,
                zIndex: 1,
                color: Cesium.Color.fromCssColorString("white"),
              },
              point: {
                pixelSize: 5,
                color: Cesium.Color.fromCssColorString(color),
                outlineColor: Cesium.Color.WHITE,
                outlineWidth: 2,
                zIndex: 2,
              },
              ellipse: null,
            });
          } else if (
            entityMap.hasOwnProperty(id) === false &&
            verifyDistancing(anchorPoint[0], anchorPoint[1], lon, lat) ===
              "OutOfLimitedBound" &&
            countDownEllipse >= 10
          ) {
            const [randomLat, randomLon] = getRandomCoordinate(lat, lon);

            entityMap[id] = viewer.entities.add({
              id: id,
              name: null,
              position: Cesium.Cartesian3.fromDegrees(
                getRandomCoordinate(randomLon, randomLat)
              ),
              description: "1 UAV is around here",
              label: {
                text: name,
                style: "FILL",
                scale: 0.75,
                pixelOffset: new Cesium.Cartesian2(0, -40),
                zIndex: 3,
              },
              description: null,
              billboard: null,
              point: null,
              ellipse: {
                semiMinorAxis: 300.0,
                semiMajorAxis: 300.0,
                height: 0.0,
                material: Cesium.Color.RED.withAlpha(0.5),
                outline: true,
                zIndex: 1,
              },
            });
          } else if (
            entityMap.hasOwnProperty(id) === false &&
            verifyDistancing(anchorPoint[0], anchorPoint[1], lon, lat) ===
              "OutOfLimitedBound" &&
            countDownEllipse < 10
          ) {
            entityMap[id] = viewer.entities.add({
              id: id,
              name: null,
              position: null,
              label: {
                text: "1",
                style: "FILL",
                scale: 0.75,
                pixelOffset: new Cesium.Cartesian2(0, -40),
                zIndex: 3,
              },
              description: null,
              billboard: null,
              point: null,
              ellipse: null,
            });
          } else if (
            entityMap.hasOwnProperty(id) === true &&
            verifyDistancing(anchorPoint[0], anchorPoint[1], lon, lat) ===
              "Inbound"
          ) {
            entityMap[id].position = Cesium.Cartesian3.fromDegrees(lon, lat);
            entityMap[id].name = `Drone - ${id}`;
            entityMap[id].label = {
              text: name,
              style: "FILL",
              scale: 0.75,
              pixelOffset: new Cesium.Cartesian2(0, -40),
              zIndex: 3,
            };
            entityMap[id].description = getDescription(
              id,
              name,
              speed,
              headDirection,
              dataTimeStamp
            );
            entityMap[id].billboard = {
              image: imageName,
              scale: 0.07,
              ready: true,
              rotation: desiredDirection,
              zIndex: 1,
              color: Cesium.Color.fromCssColorString("white"),
            };
            entityMap[id].point = {
              pixelSize: 5,
              color: Cesium.Color.fromCssColorString(color),
              outlineColor: Cesium.Color.WHITE,
              outlineWidth: 2,
            };
            entityMap[id].ellipse = null;
          } else if (
            entityMap.hasOwnProperty(id) === true &&
            verifyDistancing(anchorPoint[0], anchorPoint[1], lon, lat) ===
              "OutOfLimitedBound" &&
            countDownEllipse >= 10
          ) {
            const [randomLat, randomLon] = getRandomCoordinate(lat, lon);

            entityMap[id].position = Cesium.Cartesian3.fromDegrees(
              randomLon,
              randomLat
            );
            entityMap[id].name = null;
            entityMap[id].label = {
              text: "1",
              style: "FILL",
              scale: 0.75,
              pixelOffset: new Cesium.Cartesian2(0, -40),
              zIndex: 3,
            };
            entityMap[id].description = "1 UAV is around here";
            entityMap[id].point = null;
            entityMap[id].billboard = null;
            entityMap[id].ellipse = {
              semiMinorAxis: 300.0,
              semiMajorAxis: 300.0,
              height: 0.0,
              material: Cesium.Color.RED.withAlpha(0.5),
              outline: true,
              zIndex: 1,
            };
          } else if (
            entityMap.hasOwnProperty(id) === true &&
            verifyDistancing(anchorPoint[0], anchorPoint[1], lon, lat) ===
              "OutOfBound" &&
            countDownEllipse >= 10
          ) {
            const [randomLat, randomLon] = getRandomCoordinate(lat, lon);

            entityMap[id].position = Cesium.Cartesian3.fromDegrees(
              randomLon,
              randomLat
            );
            entityMap[id].name = null;
            entityMap[id].label = null;
            entityMap[id].description = null;
            entityMap[id].point = null;
            entityMap[id].billboard = null;
            entityMap[id].ellipse = null;
          }
        }

        updatingData[id]++;
        if (updatingData[id] > 10 && updatingData[id] < 121) {
          console.log(`${id} \nis missing for ${updatingData[id]} seconds`);
        }
        if (updatingData[id] > 120) {
          viewer.entities.remove(entityMap[id]);
          delete entityMap[id];
          delete onMessageData[id];
          delete updatingData[id];
        }
      }

      // console.log(`currently onMessageData`, onMessageData);
      // console.log(`currently entityMap : `, entityMap);
      // console.log(`currently onMessageData's Keys`, availableKeys);
      if (countDownEllipse >= 10) {
        countDownEllipse = 0;
      } else {
        countDownEllipse++;
      }
    }, 1500);

    // console.log(
    //   `Data input : ${id} \nlat: ${lat}, lon: ${lon} \nrecieveTime: ${recieveTime.toLocaleTimeString(
    //     "it-IT"
    //   )} \ncurrentTime: ${currentTime.toLocaleTimeString(
    //     "it-IT"
    //   )} \ntimeDifferent: ${Math.floor((currentUnix - time) / 1000)} seconds`
    // );

    //Later use this
    // setInterval(function () {
    //   let realTimeData = AuthServiceV2.RealTimeData();
    //   if (realTimeData != null) {
    //     realTimeData
    //       .then((response) => {
    //         const dateString = response.data.timestamp.value;
    //         const flightData = response.data.flights;
    //         // for (
    //         //   let flightStep = 0;
    //         //   flightStep < flightData.length;
    //         //   flightStep++
    //         // ) {
    //         let flightStep = 0;
    //         const id = flightData[flightStep].id;
    //         const lat = parseFloat(
    //           flightData[flightStep].current_state.position.lat
    //         );
    //         const lon = parseFloat(
    //           flightData[flightStep].current_state.position.lon
    //         );
    //         const height =
    //           flightData[flightStep].current_state.position.height.distance;
    //         const time = Math.floor(
    //           new Date(
    //             flightData[flightStep].current_state.timestamp.value
    //           ).getTime() / 1000
    //         );

    //         if (onMessageData.hasOwnProperty(id) === false) {
    //           onMessageData[id] = {
    //             id: 0,
    //             name: "",
    //             lat: [0],
    //             lon: [0],
    //             height: [0],
    //             time: [0],
    //           };

    //           let realTimeDrone = AuthServiceV3.RealTimeDrone(id);
    //           if (realTimeDrone != null) {
    //             realTimeDrone.then((response) => {
    //               onMessageData[id].name = response.data.brand_model;
    //             });
    //           }
    //         } else {
    //           if (onMessageData[id].id === 120) {
    //             onMessageData[id] = {
    //               id: 0,
    //               name: onMessageData[id].name,
    //               lat: [0],
    //               lon: [0],
    //               height: [0],
    //               time: [0],
    //             };
    //           }
    //         }

    //         updatingData[id] = 0;
    //         onMessageData[id].id++;
    //         onMessageData[id].lat.push(lat);
    //         onMessageData[id].lon.push(lon);
    //         onMessageData[id].height.push(height);
    //         onMessageData[id].time.push(time);
    //         // }
    //       })
    //       .catch((error) => {
    //         console.log(error.description);
    //       });
    //   }
    // }, 1500);

    socket.onmessage = function (event) {
      const data = JSON.parse(event.data);
      console.log(data);
      const id = data[0];
      const lat = parseFloat(data[1]);
      const lon = parseFloat(data[2]);
      const height = data[3];
      const time = data[4];
      const recieveTime = new Date(time);
      const currentTime = new Date();
      const currentUnix = Date.now();

      // console.log(id, lat, lon, height, time);
      if (
        id != null &&
        lat != null &&
        lon != null &&
        height != null &&
        time != null
      ) {
        console.log("Test")
        if (onMessageData.hasOwnProperty(id) === false) {
          onMessageData[id] = {
            id: 0,
            name: "",
            lat: [0],
            lon: [0],
            height: [0],
            time: [0],
          };

          let realTimeDrone = AuthServiceV3.RealTimeDrone(id);
          if (realTimeDrone != null) {
            realTimeDrone.then((response) => {
              onMessageData[id].name = response.data.brand_model;
            });
          }
        } else {
          if (onMessageData[id].id === 120) {
            onMessageData[id] = {
              id: 0,
              name: onMessageData[id].name,
              lat: [0],
              lon: [0],
              height: [0],
              time: [0],
            };
          }
        }

        updatingData[id] = 0;
        onMessageData[id].id++;
        onMessageData[id].lat.push(lat);
        onMessageData[id].lon.push(lon);
        onMessageData[id].height.push(height);
        onMessageData[id].time.push(time);
      }
      // updatingData[id] = 0;

      // if (onMessageData.hasOwnProperty(id) === false) {
      //   onMessageData[id] = { id: 0, lat: [], lon: [], height: [], time: [] };
      //   trailCoordinates[id] = [];
      // } else {
      //   if (onMessageData[id].id === 120) {
      //     onMessageData[id] = { id: 0, lat: [], lon: [], height: [], time: [] };
      //   }
      //   if (trailCoordinates[id].length > 40) {
      //     trailCoordinates[id].splice(0, 20);
      //   }

      //   onMessageData[id].id++;
      //   onMessageData[id].lat.push(lat);
      //   onMessageData[id].lon.push(lon);
      //   onMessageData[id].height.push(height);
      //   onMessageData[id].time.push(time);
      // }
    };
  }, []);

  return (
    <>
      <div style={{ display: "flex" }}>
        {/* <div
          style={{
            width: "10%",
            height: "91.5vh",
            background: "linear-gradient(0deg, rgba(89,89,89,1) 0%, rgba(177,177,191,1) 53%, rgba(236,236,236,1) 100%)",
          }}
        ></div> */}
        <div
          ref={mapRef}
          style={{
            width: "100%",
            height: "91.5vh",
          }}
        />
      </div>
    </>
  );
};

export default DroneMonitorSocket;
